<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M32.44 39.4L28 9.15a3 3 0 00.66-2.44c-.46-2.2-3.54-3.23-7.33-2.45s-6.21 2.94-5.76 5.15a3 3 0 001.57 2L21.5 41a3.5 3.5 0 003.5 3 2.92 2.92 0 00.51 0l4-.59a3.49 3.49 0 002.95-4zM21.94 7.19a6.19 6.19 0 013.68.15 6.17 6.17 0 01-3.33 1.58 6.13 6.13 0 01-3.68-.14 6.18 6.18 0 013.33-1.59zm-1.46 4.93a11.75 11.75 0 002.42-.26 11.78 11.78 0 002.35-.74l2.14 14.55-5.33-1.48-1.78-12.08zm8.9 28.09a.53.53 0 01-.33.2L25 41a.52.52 0 01-.57-.43l-1.89-13.14 5.33 1.49 1.6 10.92a.47.47 0 01-.09.37z"/></svg>